import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { API_ERROR_MSG } from 'adapters/constants';
import { TOAST_POSITION, TOAST_VARIANTS } from 'common/constants';
import {
  dismissErrorMessage,
  clearErrorMessages,
  getErrorMessages
} from 'components/ErrorMessageHandler/slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { messages } from './messages';
import { ErrorToast } from './styled';

export const ErrorMessage = (): React.JSX.Element => {
  const errorMessages: string[] = useAppSelector(getErrorMessages);
  const dispatch = useAppDispatch();
  const intl = useIntl();
  useEffect(() => {
    if (errorMessages[0] === API_ERROR_MSG.MISSING_COMPANY_ID) {
      dispatch(dismissErrorMessage());
    }
  }, [dispatch, errorMessages]);
  return (
    <>
      {errorMessages[0] &&
        errorMessages[0] !== API_ERROR_MSG.MISSING_COMPANY_ID && (
          <ErrorToast
            actions={[
              {
                onClick: () => {
                  dispatch(clearErrorMessages());
                },
                text: intl.formatMessage(messages.dismissButton),
                dataTestId: 'dismiss-btn'
              }
            ]}
            data-testid="toast-error"
            position={TOAST_POSITION.FIXED}
            variant={TOAST_VARIANTS.NEGATIVE}
            content={errorMessages[0]}
            id="toast-error"
          />
        )}
    </>
  );
};
